export default {
    name: "MenuGrid",

    components: {},

    props: {
        showOffers: {
            type: Boolean,
            default: true
        }
    },

    data: () => ({}),

    computed: {},

    methods: {
        goToContact() {
            if (this.$router.currentRoute.path === "/") {
                this.$router.push("/toate-asigurarile/#contact-form");
            } else if (this.$router.currentRoute.path === "/toate-asigurarile"
                || this.$router.currentRoute.path === "/toate-asigurarile/") {
                document.querySelector(`#contact-form`).scrollIntoView({
                    behavior: "smooth"
                });
            }
        }
    },

    mounted() {
        console.log(this.showOffers);
    }
};
